import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { withThemeContext } from '../Context';
import classnames from 'classnames';
import { URLS } from '@wix/da-url/dist/src/constants';
import FacebookIcon from '../Icons/Facebook';
import InstagramIcon from '../Icons/Instagram';
import TwitterIcon from '../Icons/Twitter';
import { IconSize } from '../Icons/IconWrap';
import Logo from '../Logo';
import ErrorBoundary from '../ErrorBoundary';
import s from './SiteFooter.scss';
import { withMobileContext } from '../Context';
var enhance = compose(withThemeContext, withMobileContext, withTranslation());
var SiteFooter = /** @class */ (function (_super) {
    tslib_1.__extends(SiteFooter, _super);
    function SiteFooter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuItems = [
            { key: 'siteFooter.menu.about', href: URLS.ABOUT },
            { key: 'siteFooter.menu.contact', href: URLS.CONTACT },
            { key: 'siteFooter.menu.coreMembership', href: URLS.CORE_MEMBERSHIP },
            { key: 'siteFooter.menu.careers', href: URLS.CAREERS },
            { key: 'siteFooter.menu.developers', href: URLS.DEVELOPERS },
            { key: 'siteFooter.menu.advertise', href: URLS.ADVERTISE },
            { key: 'siteFooter.menu.termsOfService', href: URLS.TOS },
            { key: 'siteFooter.menu.etiquette', href: URLS.ETIQUETTE },
            { key: 'siteFooter.menu.privacyPolicy', href: URLS.PRIVACY },
            { key: 'siteFooter.menu.copyrightPolicy', href: URLS.COPYRIGHT },
            { key: 'siteFooter.menu.helpAndFaq', href: URLS.HELP },
        ];
        return _this;
    }
    SiteFooter.prototype.renderMenuItem = function (item) {
        return (React.createElement("div", { className: s['menu__block__item'], key: item.key },
            React.createElement("a", { className: s['link'], href: item.href }, this.props.t(item.key))));
    };
    SiteFooter.prototype.renderSocialButtons = function () {
        var socialButtons = [
            { icon: FacebookIcon, href: 'https://www.facebook.com/deviantart/' },
            { icon: InstagramIcon, href: 'https://www.instagram.com/deviantart/' },
            { icon: TwitterIcon, href: 'https://twitter.com/DeviantArt' },
        ];
        return (React.createElement("div", { className: s['social-networks'] }, socialButtons.map(function (sb, index) { return (React.createElement("a", { key: index, className: s['social-networks__button'], href: sb.href },
            React.createElement(sb.icon, { size: IconSize.MEDIUM, className: classnames(s['social-networks__icon'], s['link']) }))); })));
    };
    SiteFooter.prototype.render = function () {
        var _this = this;
        var copyrightKey = 'siteFooter.copyright';
        var allRightsReservedKey = 'siteFooter.allRightsReserved';
        var theme = this.props.theme;
        var isDarkTheme = theme === 'dark';
        return (React.createElement("div", { className: s['root'] },
            React.createElement(ErrorBoundary, { hideOnFail: true },
                React.createElement("div", { className: s['columns'] },
                    React.createElement("div", { className: classnames(s['logo-block'], s['column']) },
                        React.createElement("a", { href: "https://deviantart.com/" },
                            React.createElement(Logo, { className: classnames(s['logo']), markColor: isDarkTheme ? 'white' : 'black', textColor: isDarkTheme ? 'white' : 'black', size: "small" }))),
                    React.createElement("div", { className: classnames(s['multicolumn'], s['column']) }, this.menuItems.map(function (item) { return _this.renderMenuItem(item); })),
                    React.createElement("div", { className: classnames(s['social-block'], s['column']) }, this.renderSocialButtons()),
                    this.props.isMobile && (React.createElement("div", { className: s['copyright'] },
                        React.createElement("div", null, this.props.t(copyrightKey)),
                        React.createElement("div", { className: s['separator'] }),
                        React.createElement("div", null, this.props.t(allRightsReservedKey))))),
                !this.props.isMobile && (React.createElement("div", { className: s['copyright'] },
                    React.createElement("div", null, this.props.t(copyrightKey, { year: new Date().getFullYear() })),
                    React.createElement("div", null, this.props.t(allRightsReservedKey)))))));
    };
    return SiteFooter;
}(React.Component));
export { SiteFooter };
export default enhance(SiteFooter);
//# sourceMappingURL=SiteFooter.js.map